import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { Outlet } from "react-router-dom";
import Header from "./components/Header";
import { Toaster } from "./components/ui/sonner";
import UpdateDialog from "./components/UpdateDialog";
import useGetTheme from "./lib/hooks/useGetTheme";
import PWAPrompt from "react-ios-pwa-prompt";
import { Capacitor } from "@capacitor/core";

export default function Layout({
  updateAvailable,
}: {
  updateAvailable: boolean;
}) {
  const theme = useGetTheme();

  useEffect(() => {
    document.documentElement.classList.add(theme);
    return () => {
      document.documentElement.classList.remove(theme);
    };
  }, [theme]);

  return (
    <div>
      <Helmet>
        <meta
          name="theme-color"
          content={theme === "light" ? "#FFFFFF" : "#020817"}
        />
      </Helmet>
      <Header />
      <Outlet />
      {!Capacitor.isNativePlatform() && (
        <PWAPrompt
          timesToShow={3}
          promptOnVisit={1}
          delay={2000}
          timeToClose={12000}
          copyTitle="Nainstalovat aplikaci"
          copyDescription="Tuto aplikaci je možné si nainstalovat do svého mobilního telefonu a používat ji jako klasickou aplikaci offline."
          copySubtitle="Alkulačka"
          copyShareStep="Stiskni tlačítko 'Sdílet' v dolním panelu"
          copyAddToHomeScreenStep="Stiskni 'Přidat na plochu'"
          appIconPath="/android-chrome-512x512.png"
        />
      )}
      <Toaster />
      <UpdateDialog updateAvailable={updateAvailable} />
    </div>
  );
}
